




































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Surface, Typography, Picture } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import MarketingCenterService from '@/api/MarketingCenterService';
import eventBus from '@/utils/eventBus';

@Component({ components: { Surface, Typography, Picture, FilledButton } })
export default class MarketingCenterConfirmModal extends Vue {
  @Prop(String) readonly postId?: string;
  @Prop({ default: () => {} }) onSave!: () => void;

  service = new MarketingCenterService();
  loading: boolean = false;

  discard() {
    this.$router.push('/marketing-center/social-media-templates');
    this.onClose();
  }

  onClose() {
    eventBus.$emit('closeModal');
  }
}
